type SendBeaconHandle = (...signs: string[]) => any;

let sendBeaconHandle: SendBeaconHandle | null = null;

export function setBeaconHandle(sendBeaconApi: SendBeaconHandle) {
  sendBeaconHandle = sendBeaconApi;
}

export function beaconHandle(id: string) {
  if (!sendBeaconHandle) {
    return;
  }
  sendBeaconHandle(id);
}

export type { SendBeaconHandle };
